import React from "react";
import "./PNF.css";
import Layout from "../Layout/Layout";

const PNF = () => {
  return (
    <Layout>
      <div className="PNF-container">
        <div className="wrapper">
          <h1>
            404 <br /> Page not found!!
          </h1>
        </div>
      </div>
    </Layout>
  );
};

export default PNF;
